import React from "react";
import { StringWidget } from "./StringWidget";

export function EmailWidget(props) {

  const actionButtonOptions =
  {
    icon: 'email',
    action: (value) => {
      window.open("mailto:" + value, "_self");
    }
  };

  return (
    <StringWidget
      isBaseWidgetFor="EmailWidget"
      actionButtonOptions={actionButtonOptions}
      {...props}
    />
  );
}